import { USER_ROLES } from '../utils/appConstants';

// Get franchisee ID for data loading context
export const getFranchiseeIdForDataLoading = (user) => {
  if (!user) return null;

  if (user.role === USER_ROLES.ADMIN && user.franchiseeId) {
    return user.franchiseeId; // Admin impersonating
  } else if (user.role === USER_ROLES.ADMIN) {
    return 'all'; // Admin sees all
  } else if (user.role === USER_ROLES.FRANCHISEE) {
    return user.id;
  } else if (user.role === USER_ROLES.TECHNICIAN && (user.franchiseeId || user.assignedFranchiseeId)) {
    return user.franchiseeId || user.assignedFranchiseeId;
  }

  return null;
};

// Get franchisee ID for CRUD operations
// Always pass entityFranchiseeId when operating on an existing entity —
// this prevents admin users (whose user.id is 'admin-user-id') from 404-ing.
export const getFranchiseeIdForCRUD = (user, entityFranchiseeId) => {
  if (entityFranchiseeId) return entityFranchiseeId;
  if (!user) return null;
  // Admin users without a franchiseeId should use 'all' for CRUD operations
  if (user.role === 'admin' && !user.franchiseeId) return 'all';
  return user.franchiseeId || user.id;
};

// Check if current route is an OAuth callback
export const isOAuthRoute = (pathname) => {
  return pathname === '/quickbooks/callback' || pathname === '/qb/done';
};